import { Controller } from "@hotwired/stimulus"

// ปิดการ์ดแบบถาวร: ถอดการ์ดออกจากหน้าทันที แล้วยิงบอกเซิร์ฟเวอร์ให้จำ (ไม่ต้องรีโหลด)
export default class extends Controller {
  static values = { url: String }

  dismiss() {
    this.element.remove()
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.urlValue, { method: "DELETE", headers: { "X-CSRF-Token": token } })
  }
}
